module.exports = __webpack_public_path__ + "media/images/indeed_icon-20938a123f11929e291206128d59d549.png";